/* eslint-disable react/prop-types */
import React from 'react';
import { Col, Form } from 'antd';

import {
  DocumentExampleCNH,
  DocumentExampleRG,
  DocumentExampleIRPF1,
  DocumentExampleIRPF2,
  DocumentExampleIRPF3,
  DocumentExampleIRPF4,
  DocumentExampleIRPF5,
  DocumentExampleIRPF6,
  DocumentExampleIRPF7,
  DocumentExampleIRPF8,
  DocumentExampleIRPF9,
} from 'assets/images';

import { UploadCard } from 'components';

const { Item } = Form;

const alerts = {
  idCard: (
    <>
      O documento deve estar na validade e a foto em boa qualidade. Envie apenas <b>UMA FOTO</b> do
      documento aberto. Visualize o exemplo para instruções mais detalhadas.
    </>
  ),
  proofOfIncome: (
    <>
      Comprovante de renda (holerite, IRPF, DECORE, extrato do INSS, declaração de renda de autônomo
      com assinatura reconhecida em cartório)
    </>
  ),
  proofOfIncomeReceipt: (
    <>
      Recibo da Declaração Imposto de Renda. Caso não tenha declarado, envie recibo de comprovante
      de <b>NÃO DECLARANTE DE IMPOSTO DE RENDA</b>.
    </>
  ),
  proofOfAddress: (
    <>
      Comprovante de Endereço atualizado (emissão de até 120 dias): Serão aceitos como documentos de
      comprovação de residência: Contas de Concessionárias de Serviços Públicos (Luz, água, gás);
      Contas de Telefonia fixo ou móvel; Serviço de TV por assinatura ou Internet Banda Larga;
      Boleto de cobrança de condomínio; Fatura de cartão de crédito; Demonstrativo ou comunicado do
      Instituto Nacional do Seguro Social (INSS) ou da Receita Federal do Brasil (RFB); Extrato do
      Fundo de Garantia do Tempo de Serviço (FGTS)
    </>
  ),
};

const fileExamples = {
  idCard: [DocumentExampleRG, DocumentExampleCNH],
  proofOfIncome: [
    DocumentExampleIRPF1,
    DocumentExampleIRPF2,
    DocumentExampleIRPF3,
    DocumentExampleIRPF4,
    DocumentExampleIRPF5,
    DocumentExampleIRPF6,
    DocumentExampleIRPF7,
    DocumentExampleIRPF8,
    DocumentExampleIRPF9,
  ],
};

const BadesulUpload = ({ input, selectedBusinessUser, saveBusinessUser, form, sizeMap }) => {
  let pointer = selectedBusinessUser?.user;
  let fileName = input.value;

  if (input.value.includes('partner')) {
    const filePart = input.value.split('partner')[1];
    pointer = selectedBusinessUser?.user?.civilPartner;
    const firstLetter = filePart[0].toLowerCase();
    fileName = `${firstLetter}${filePart.slice(1)}`;
  }
  return (
    <Col {...sizeMap.large} className="document-col">
      <Item
        name={input.value}
        rules={
          input.notRequired
            ? []
            : [
                {
                  required: true,
                  message: `Insira o ${input.name}`,
                },
              ]
        }
      >
        <UploadCard
          id="idCardFileId"
          accept="image/png,image/jpeg,application/pdf"
          label={input.name}
          exampleImages={fileExamples[input.value]}
          alert={alerts[input.value]}
          actualFile={pointer?.[fileName]}
          onCompleted={async ({ id }) => {
            const { mutation, baseVariables } = saveBusinessUser;

            const variables = baseVariables();

            variables[`${input.value}FileId`] = id;

            mutation({
              variables,
            });

            const obj = {};
            obj[input.value] = id;
            await form.setFieldsValue(obj);
          }}
        />
      </Item>
    </Col>
  );
};

export default BadesulUpload;
